<template>
  <div class="dashboard-container">
    <a-row :gutter="20" class="dashboard">
      <a-col :span="isDesktop ? 16 : 24">
        <a-card :title="$t('cardTitle.cardOrderForm')" class="style3">
          <iframe
            onload="window.parent.scrollTo(0,0)"
            allowtransparency="true"
            src="https://form.jotform.com/210811006667247"
            style="width: 1px; min-width: 100%; height: 640px; border: medium none;"
            scrolling="no"
            frameborder="0"
          ></iframe>
        </a-card>
      </a-col>
      <a-col :span="isDesktop ? 8 : 24">
        <a-card :title="$t('cardTitle.instructionsResources')" class="style3">
          <p>{{ $t('page.orderCards.instructionsResources.para1') }}</p>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  methods: {
    openLink(url, isLink = false) {
      if (isLink) {
        window.location.href = url;
      } else {
        this.$router.push({ name: url });
      }
    },
  },
};
</script>
<style lang="scss">
.dashboard-container.content-page {
  padding: 0 !important;
  .dashboard {
    padding: 20px;
    .ant-btn {
      height: 100%;
      white-space: initial;
    }
  }
}
</style>
